var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","color":"exercise"},on:{"click":function($event){return _vm.handleClick()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.userPostLike && _vm.userPostLike.id ? "mdi-heart" : "mdi-heart-outline"))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }